import { render, staticRenderFns } from "./methods.vue?vue&type=template&id=55cbde1c"
import script from "./methods.vue?vue&type=script&lang=js"
export * from "./methods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports